module.exports = function kamigameDataEmbed(md) {
  md.core.ruler.before('block', 'kamigame_data_embed', function replace(state) {
    state.src = state.src.replace(/\$\$?\(.*?\){([^}]*)}/g, (matches, p1) => {
      return p1.replace(/(\\n|｛|｝)/g, (matched) => {
        return {
          '\\n': '\n',
          '｛': '{',
          '｝': '}',
        }[matched] || matched;
      });
    });

    return true;
  });
};
